// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerCharacteristicType {
    id: number;
    customerCharacteristicCategoryType: string;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CustomerCharacteristicType implements ICustomerCharacteristicType, IBaseType {
    public id: number;
    public customerCharacteristicCategoryType: string;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
        Returns VA 100% Disabled CustomerCharacteristicType
    **/
    get DisabledVeteran(): ICustomerCharacteristicType {
        return this.FromId(1);
    }
    /**
        Returns Emancipated Minor CustomerCharacteristicType
    **/
    get EmancipatedMinor(): ICustomerCharacteristicType {
        return this.FromId(2);
    }
    /**
        Returns Military Personnel (DL) CustomerCharacteristicType
    **/
    get MilitaryPersonnelDL(): ICustomerCharacteristicType {
        return this.FromId(3);
    }
    /**
        Returns Non-Profit CustomerCharacteristicType
    **/
    get NonProfit(): ICustomerCharacteristicType {
        return this.FromId(4);
    }
    /**
        Returns Non-Resident Military CustomerCharacteristicType
    **/
    get NonResidentMilitary(): ICustomerCharacteristicType {
        return this.FromId(5);
    }
    /**
        Returns Permanently Disabled CustomerCharacteristicType
    **/
    get PermanentlyDisabled(): ICustomerCharacteristicType {
        return this.FromId(6);
    }
    /**
        Returns Public Health Services Officer CustomerCharacteristicType
    **/
    get PublicHealthServicesOfficer(): ICustomerCharacteristicType {
        return this.FromId(7);
    }
    /**
        Returns School Bus Driver CustomerCharacteristicType
    **/
    get SchoolBusDriver(): ICustomerCharacteristicType {
        return this.FromId(8);
    }
    /**
        Returns Sex Offender CustomerCharacteristicType
    **/
    get SexOffender(): ICustomerCharacteristicType {
        return this.FromId(9);
    }
    /**
        Returns Supplemental Security Income (SSI) CustomerCharacteristicType
    **/
    get SupplementalSecurityIncome(): ICustomerCharacteristicType {
        return this.FromId(10);
    }
    /**
        Returns Surviving Spouse CustomerCharacteristicType
    **/
    get SurvivingSpouse(): ICustomerCharacteristicType {
        return this.FromId(11);
    }
    /**
        Returns Temporarily Disabled CustomerCharacteristicType
    **/
    get TemporarilyDisabled(): ICustomerCharacteristicType {
        return this.FromId(12);
    }
    /**
        Returns Tribal Member CustomerCharacteristicType
    **/
    get TribalMember(): ICustomerCharacteristicType {
        return this.FromId(13);
    }
    /**
        Returns Veteran CustomerCharacteristicType
    **/
    get Veteran(): ICustomerCharacteristicType {
        return this.FromId(14);
    }
    /**
        Returns Fee Exempt Commercial Permit CustomerCharacteristicType
    **/
    get FeeExemptCommercialPermit(): ICustomerCharacteristicType {
        return this.FromId(15);
    }
    /**
        Returns Government Agency CustomerCharacteristicType
    **/
    get GovernmentAgency(): ICustomerCharacteristicType {
        return this.FromId(18);
    }
    /**
        Returns Transporter CustomerCharacteristicType
    **/
    get Transporter(): ICustomerCharacteristicType {
        return this.FromId(19);
    }
    /**
        Returns Address Confidentiality Program CustomerCharacteristicType
    **/
    get AddressConfidentialityProgram(): ICustomerCharacteristicType {
        return this.FromId(22);
    }
    /**
        Returns Amateur Radio CustomerCharacteristicType
    **/
    get AmateurRadio(): ICustomerCharacteristicType {
        return this.FromId(23);
    }
    /**
        Returns Arizona Historical Society CustomerCharacteristicType
    **/
    get ArizonaHistoricalSociety(): ICustomerCharacteristicType {
        return this.FromId(24);
    }
    /**
        Returns Congressional Medal of Honor CustomerCharacteristicType
    **/
    get CongressionalMedalofHonor(): ICustomerCharacteristicType {
        return this.FromId(25);
    }
    /**
        Returns Firefighter CustomerCharacteristicType
    **/
    get Firefighter(): ICustomerCharacteristicType {
        return this.FromId(26);
    }
    /**
        Returns Former Prisoner of War CustomerCharacteristicType
    **/
    get FormerPrisonerofWar(): ICustomerCharacteristicType {
        return this.FromId(27);
    }
    /**
        Returns Fraternal Order of Police CustomerCharacteristicType
    **/
    get FraternalOrderofPolice(): ICustomerCharacteristicType {
        return this.FromId(28);
    }
    /**
        Returns Gold Star Family CustomerCharacteristicType
    **/
    get GoldStarFamily(): ICustomerCharacteristicType {
        return this.FromId(29);
    }
    /**
        Returns Government CustomerCharacteristicType
    **/
    get Government(): ICustomerCharacteristicType {
        return this.FromId(30);
    }
    /**
        Returns Honorary Foreign Consular CustomerCharacteristicType
    **/
    get HonoraryForeignConsular(): ICustomerCharacteristicType {
        return this.FromId(32);
    }
    /**
        Returns Legion of Valor CustomerCharacteristicType
    **/
    get LegionofValor(): ICustomerCharacteristicType {
        return this.FromId(33);
    }
    /**
        Returns National Guard CustomerCharacteristicType
    **/
    get NationalGuard(): ICustomerCharacteristicType {
        return this.FromId(34);
    }
    /**
        Returns OOP/IAH CustomerCharacteristicType
    **/
    get OOPIAH(): ICustomerCharacteristicType {
        return this.FromId(35);
    }
    /**
        Returns Pearl Harbor Survivor CustomerCharacteristicType
    **/
    get PearlHarborSurvivor(): ICustomerCharacteristicType {
        return this.FromId(36);
    }
    /**
        Returns Purple Heart Medal CustomerCharacteristicType
    **/
    get PurpleHeartMedal(): ICustomerCharacteristicType {
        return this.FromId(37);
    }
    /**
        Returns Qualified Surviving Member for Exemption CustomerCharacteristicType
    **/
    get QualifiedSurvivingMemberforExemption(): ICustomerCharacteristicType {
        return this.FromId(38);
    }
    /**
        Returns Qualified Surviving Member for Plate CustomerCharacteristicType
    **/
    get QualifiedSurvivingMemberforPlate(): ICustomerCharacteristicType {
        return this.FromId(39);
    }
    /**
        Returns Restricted Record CustomerCharacteristicType
    **/
    get RestrictedRecord(): ICustomerCharacteristicType {
        return this.FromId(40);
    }
    /**
        Returns Orgs that transport citizens with disabilities CustomerCharacteristicType
    **/
    get PermanentlyDisabledTransporter(): ICustomerCharacteristicType {
        return this.FromId(43);
    }
    /**
        Returns Intrinsic CustomerCharacteristicType
    **/
    get Intrinsic(): ICustomerCharacteristicType {
        return this.FromId(44);
    }
    /**
        Returns Transient  CustomerCharacteristicType
    **/
    get Transient(): ICustomerCharacteristicType {
        return this.FromId(45);
    }
    /**
        Returns Electronic Lien Title CustomerCharacteristicType
    **/
    get ElectronicLienTitle(): ICustomerCharacteristicType {
        return this.FromId(46);
    }
    /**
        Returns Deaf / Hard of Hearing CustomerCharacteristicType
    **/
    get HearingImpaired(): ICustomerCharacteristicType {
        return this.FromId(47);
    }
    /**
        Returns Suspend Digital Disbursement CustomerCharacteristicType
    **/
    get SuspendDigitalDisbursement(): ICustomerCharacteristicType {
        return this.FromId(48);
    }
    /**
        Returns PDS - Motorcycle CustomerCharacteristicType
    **/
    get PDSMotorcycle(): ICustomerCharacteristicType {
        return this.FromId(50);
    }
    /**
        Returns PDS - Special Performance CustomerCharacteristicType
    **/
    get PDSSpecialPerformance(): ICustomerCharacteristicType {
        return this.FromId(51);
    }
    /**
        Returns Restricted Distributor CustomerCharacteristicType
    **/
    get RestrictedDistributor(): ICustomerCharacteristicType {
        return this.FromId(52);
    }
    /**
        Returns Department of Child Safety CustomerCharacteristicType
    **/
    get DepartmentofChildSafety(): ICustomerCharacteristicType {
        return this.FromId(53);
    }
    /**
        Returns Scrap Dealer CustomerCharacteristicType
    **/
    get ScrapDealer(): ICustomerCharacteristicType {
        return this.FromId(54);
    }
    /**
        Returns Auto Recycler CustomerCharacteristicType
    **/
    get AutoRecycler(): ICustomerCharacteristicType {
        return this.FromId(55);
    }
    /**
        Returns Insurance CustomerCharacteristicType
    **/
    get Insurance(): ICustomerCharacteristicType {
        return this.FromId(56);
    }
    /**
        Returns Dealer CustomerCharacteristicType
    **/
    get Dealer(): ICustomerCharacteristicType {
        return this.FromId(57);
    }
    /**
        Returns PDS - Operator CustomerCharacteristicType
    **/
    get PDSOperator(): ICustomerCharacteristicType {
        return this.FromId(58);
    }
    /**
        Returns PDS - High School CustomerCharacteristicType
    **/
    get PDSHighSchool(): ICustomerCharacteristicType {
        return this.FromId(59);
    }
    /**
        Returns MVD Business Partner Customer CustomerCharacteristicType
    **/
    get MVDBusinessPartnerCustomer(): ICustomerCharacteristicType {
        return this.FromId(60);
    }
    /**
        Returns Traffic Survival School CustomerCharacteristicType
    **/
    get TrafficSurvivalSchool(): ICustomerCharacteristicType {
        return this.FromId(61);
    }
    /**
        Returns Light Sensitivity Window Tint CustomerCharacteristicType
    **/
    get LightSensitivityWindowTint(): ICustomerCharacteristicType {
        return this.FromId(62);
    }
    /**
        Returns Restricted Portal Account CustomerCharacteristicType
    **/
    get RestrictedPortalAccount(): ICustomerCharacteristicType {
        return this.FromId(63);
    }
    /**
        Returns PDS - Commercial CustomerCharacteristicType
    **/
    get PDSCommercial(): ICustomerCharacteristicType {
        return this.FromId(64);
    }
    /**
        Returns Trusted Organization CustomerCharacteristicType
    **/
    get TrustedOrg(): ICustomerCharacteristicType {
        return this.FromId(65);
    }
    /**
        Returns Information Services CustomerCharacteristicType
    **/
    get InformationServices(): ICustomerCharacteristicType {
        return this.FromId(66);
    }
    /**
        Returns Watch Your Car CustomerCharacteristicType
    **/
    get WatchYourCar(): ICustomerCharacteristicType {
        return this.FromId(1065);
    }
    /**
        Returns Ops of Law Placement CustomerCharacteristicType
    **/
    get OpsofLawPlacement(): ICustomerCharacteristicType {
        return this.FromId(2065);
    }
    /**
        Returns Secretary of State CustomerCharacteristicType
    **/
    get SecretaryofState(): ICustomerCharacteristicType {
        return this.FromId(2066);
    }
    /**
        Returns Administrative Offices of the Courts CustomerCharacteristicType
    **/
    get AOC(): ICustomerCharacteristicType {
        return this.FromId(2067);
    }
    /**
        Returns Disable ABV Notifications CustomerCharacteristicType
    **/
    get DisableABVNotifications(): ICustomerCharacteristicType {
        return this.FromId(2068);
    }
    /**
        Returns Government MVR Qualified CustomerCharacteristicType
    **/
    get GovernmentMVRQualified(): ICustomerCharacteristicType {
        return this.FromId(2069);
    }
    /**
        Returns Organization Restricted Record CustomerCharacteristicType
    **/
    get OrgRestrictedRecord(): ICustomerCharacteristicType {
        return this.FromId(2070);
    }
    /**
        Returns Government Photo Qualified CustomerCharacteristicType
    **/
    get GovernmentPhotoQualified(): ICustomerCharacteristicType {
        return this.FromId(2071);
    }
    /**
        Returns Parent Guardian Of Permanently Disabled Minor CustomerCharacteristicType
    **/
    get ParentGaurdianOfPermDisabledMinor(): ICustomerCharacteristicType {
        return this.FromId(2072);
    }
    /**
        Returns Individual Elevated MAX Balance CustomerCharacteristicType
    **/
    get IndElevatedMAXBalance(): ICustomerCharacteristicType {
        return this.FromId(2073);
    }
    /**
        Returns Organization Elevated MAX Balance CustomerCharacteristicType
    **/
    get OrgElevatedMAXBalance(): ICustomerCharacteristicType {
        return this.FromId(2074);
    }
    /**
        Returns Humanitarian Parole CustomerCharacteristicType
    **/
    get HumanitarianParole(): ICustomerCharacteristicType {
        return this.FromId(2075);
    }
    /**
        Returns Organization OOP/IAH CustomerCharacteristicType
    **/
    get OrgOOPIAH(): ICustomerCharacteristicType {
        return this.FromId(2076);
    }
    /**
        Returns Organization CDL MEC MVR CustomerCharacteristicType
    **/
    get OrgCDLMECMVR(): ICustomerCharacteristicType {
        return this.FromId(2077);
    }
    /**
        Returns IRP/IFTA CustomerCharacteristicType
    **/
    get IRPIFTA(): ICustomerCharacteristicType {
        return this.FromId(2078);
    }
    /**
        Returns Non-Resident Military Spouse CustomerCharacteristicType
    **/
    get NonResidentMilitarySpouse(): ICustomerCharacteristicType {
        return this.FromId(2079);
    }
    /**
        Returns Government Compliance Report CustomerCharacteristicType
    **/
    get GovernmentComplianceReport(): ICustomerCharacteristicType {
        return this.FromId(2080);
    }
    /**
        Returns Motor Carrier Individual CustomerCharacteristicType
    **/
    get MotorCarrierIndividual(): ICustomerCharacteristicType {
        return this.FromId(2081);
    }
    /**
        Returns Motor Carrier Organization CustomerCharacteristicType
    **/
    get MotorCarrierOrganization(): ICustomerCharacteristicType {
        return this.FromId(2082);
    }
    /**
        Returns Motor Carrier Processor CustomerCharacteristicType
    **/
    get MotorCarrierProcessor(): ICustomerCharacteristicType {
        return this.FromId(2083);
    }
    /**
        Returns Purple Heart Recipient CustomerCharacteristicType
    **/
    get PurpleHeartRecipient(): ICustomerCharacteristicType {
        return this.FromId(2084);
    }
    /**
        Returns AZMVDNow Org Vehicle MVR CustomerCharacteristicType
    **/
    get MVDNowOrgVehicleMVR(): ICustomerCharacteristicType {
        return this.FromId(2085);
    }
    /**
        Returns Financial Institution CustomerCharacteristicType
    **/
    get FinancialInstitution(): ICustomerCharacteristicType {
        return this.FromId(2086);
    }
    /**
        Returns Immediate Family Member of a Veteran for Plate CustomerCharacteristicType
    **/
    get ImmediateFamilyMemberofaVeteranforPlate(): ICustomerCharacteristicType {
        return this.FromId(2087);
    }
    /**
        Returns Distinguished Flying Cross CustomerCharacteristicType
    **/
    get DistinguishedFlyingCross(): ICustomerCharacteristicType {
        return this.FromId(2088);
    }
    /**
        Returns Insurance Institution CustomerCharacteristicType
    **/
    get InsuranceInstitution(): ICustomerCharacteristicType {
        return this.FromId(2089);
    }
    /**
        Returns IRP/IFTA CustomerCharacteristicType
    **/
    get IRPIFTAOrg(): ICustomerCharacteristicType {
        return this.FromId(2090);
    }
    /**
        Returns Limited Trust Organization CustomerCharacteristicType
    **/
    get LimitedTrustOrg(): ICustomerCharacteristicType {
        return this.FromId(2091);
    }
    /**
        Returns TeleMVD Kiosk Location CustomerCharacteristicType
    **/
    get TeleMVDKioskLocation(): ICustomerCharacteristicType {
        return this.FromId(2092);
    }
    /**
        Returns Tower CustomerCharacteristicType
    **/
    get Tower(): ICustomerCharacteristicType {
        return this.FromId(2093);
    }
    /**
        Returns Arizona DoC Rehabilitation and Reentry CustomerCharacteristicType
    **/
    get ADCRR(): ICustomerCharacteristicType {
        return this.FromId(2094);
    }
    /**
        Returns Government Vehicle Documents CustomerCharacteristicType
    **/
    get GovernmentVehicleDocuments(): ICustomerCharacteristicType {
        return this.FromId(2095);
    }
    /**
        Returns Crash Records Viewer CustomerCharacteristicType
    **/
    get CrashRecordsViewer(): ICustomerCharacteristicType {
        return this.FromId(2096);
    }
    /**
        Returns Crash Records DPS CustomerCharacteristicType
    **/
    get CrashRecordsDPS(): ICustomerCharacteristicType {
        return this.FromId(2097);
    }
    /**
        Returns Donor Network Reports CustomerCharacteristicType
    **/
    get DonorNetworkReports(): ICustomerCharacteristicType {
        return this.FromId(2098);
    }
    /**
        Returns Government Fee Exemption CustomerCharacteristicType
    **/
    get GovernmentFeeExemption(): ICustomerCharacteristicType {
        return this.FromId(2099);
    }
    /**
        Returns Mobile Home CustomerCharacteristicType
    **/
    get MobileHome(): ICustomerCharacteristicType {
        return this.FromId(2100);
    }
    /**
        Returns Pre 96 CustomerCharacteristicType
    **/
    get Pre96(): ICustomerCharacteristicType {
        return this.FromId(2101);
    }
    /**
        Returns OHV Education Individual CustomerCharacteristicType
    **/
    get OHVEducationIndividual(): ICustomerCharacteristicType {
        return this.FromId(2102);
    }
    /**
        Returns OHV Education Organization CustomerCharacteristicType
    **/
    get OHVEducationOrganization(): ICustomerCharacteristicType {
        return this.FromId(2103);
    }
    /**
        Returns Claim AMN Account In Office CustomerCharacteristicType
    **/
    get ClaimAMNAccountInOffice(): ICustomerCharacteristicType {
        return this.FromId(2104);
    }
    /**
        Returns Communication Accommodation CustomerCharacteristicType for Vehicle
    **/
    get CommunicationAccommodationVehicle(): ICustomerCharacteristicType {
        return this.FromId(2105);
    }
    /**
      Returns Communication Accommodation CustomerCharacteristicType for Customer
    **/
    get CommunicationAccommodationCustomer(): ICustomerCharacteristicType {
        return this.FromId(2106);
    }
    /**
        Returns Native American Credential Designation CustomerCharacteristicType
    **/
    get NativeAmericanCredentialDesignation(): ICustomerCharacteristicType {
        return this.FromId(2108);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, customerCharacteristicCategoryType: 'Individual', value: 'DisabledVeteran', displayValue: 'VA 100% Disabled', description: 'To identify that the customer is a disabled veteran.', sortOrder: 999999, active: true });
        this._dictionary.add('2', { id: 2, customerCharacteristicCategoryType: 'Individual', value: 'EmancipatedMinor', displayValue: 'Emancipated Minor', description: 'To document that the customer is an emancipated minor.  ', sortOrder: 999999, active: true });
        this._dictionary.add('3', { id: 3, customerCharacteristicCategoryType: 'Individual', value: 'MilitaryPersonnel(DL)', displayValue: 'Military Personnel (DL)', description: 'To identify the records of active duty military personnel .', sortOrder: 999999, active: true });
        this._dictionary.add('4', { id: 4, customerCharacteristicCategoryType: 'Organization', value: 'Non-Profit', displayValue: 'Non-Profit', description: 'To identify that the customer is a non-profit organization.', sortOrder: 999999, active: true });
        this._dictionary.add('5', { id: 5, customerCharacteristicCategoryType: 'Individual', value: 'Non-ResidentMilitary', displayValue: 'Non-Resident Military', description: 'To identify that the customer is a non-resident military personnel.', sortOrder: 999999, active: true });
        this._dictionary.add('6', { id: 6, customerCharacteristicCategoryType: 'Individual', value: 'PermanentlyDisabled', displayValue: 'Permanently Disabled', description: 'To identify that the customer is permanently disabled.', sortOrder: 999999, active: true });
        this._dictionary.add('7', { id: 7, customerCharacteristicCategoryType: 'Individual', value: 'PublicHealthServicesOfficer', displayValue: 'Public Health Services Officer', description: 'To identify that the customer is a public health services officer.', sortOrder: 999999, active: true });
        this._dictionary.add('8', { id: 8, customerCharacteristicCategoryType: 'Individual', value: 'SchoolBusDriver', displayValue: 'School Bus Driver', description: 'To identify all drivers currently certified by  (DPS) for the operation of a school bus.', sortOrder: 999999, active: true });
        this._dictionary.add('9', { id: 9, customerCharacteristicCategoryType: 'Individual', value: 'SexOffender', displayValue: 'Sex Offender', description: 'To identify all persons subject to registration as a “Sex Offender”.', sortOrder: 999999, active: true });
        this._dictionary.add('10', { id: 10, customerCharacteristicCategoryType: 'Individual', value: 'SupplementalSecurityIncome', displayValue: 'Supplemental Security Income (SSI)', description: 'To document that the customer is a current recipient of SSI .', sortOrder: 999999, active: true });
        this._dictionary.add('11', { id: 11, customerCharacteristicCategoryType: 'Individual', value: 'SurvivingSpouse', displayValue: 'Surviving Spouse', description: 'To identify that the customer is a surviving spouse.', sortOrder: 999999, active: true });
        this._dictionary.add('12', { id: 12, customerCharacteristicCategoryType: 'Individual', value: 'TemporarilyDisabled', displayValue: 'Temporarily Disabled', description: 'To identify that the customer is temporarily disabled.', sortOrder: 999999, active: true });
        this._dictionary.add('13', { id: 13, customerCharacteristicCategoryType: 'Individual', value: 'TribalMember', displayValue: 'Tribal Member', description: 'To indicate that a customer is a tribal member.', sortOrder: 999999, active: true });
        this._dictionary.add('14', { id: 14, customerCharacteristicCategoryType: 'Individual', value: 'Veteran', displayValue: 'Veteran', description: 'To identify that the customer is a veteran.', sortOrder: 999999, active: true });
        this._dictionary.add('15', { id: 15, customerCharacteristicCategoryType: 'Organization', value: 'FeeExemptCommercialPermit', displayValue: 'Fee Exempt Commercial Permit', description: 'Fee Exempt Commercial Permit', sortOrder: 999999, active: true });
        this._dictionary.add('18', { id: 18, customerCharacteristicCategoryType: 'Organization', value: 'GovernmentAgency', displayValue: 'Government Agency', description: 'To identify that the customer is a government agency.', sortOrder: 999999, active: true });
        this._dictionary.add('19', { id: 19, customerCharacteristicCategoryType: 'Organization', value: 'Transporter', displayValue: 'Transporter', description: 'To identify that the customer is a transporter.', sortOrder: 999999, active: true });
        this._dictionary.add('22', { id: 22, customerCharacteristicCategoryType: 'Individual', value: 'AddressConfidentialityProgram', displayValue: 'Address Confidentiality Program', description: 'To identify that the customer will have certain data redacted.', sortOrder: 999999, active: true });
        this._dictionary.add('23', { id: 23, customerCharacteristicCategoryType: 'Individual', value: 'AmateurRadio', displayValue: 'Amateur Radio', description: 'To identify that the customer belongs to the amateur radio.', sortOrder: 999999, active: true });
        this._dictionary.add('24', { id: 24, customerCharacteristicCategoryType: 'Individual', value: 'ArizonaHistoricalSociety', displayValue: 'Arizona Historical Society', description: 'To identify that the customer belongs to the Arizona Historical Society.', sortOrder: 999999, active: true });
        this._dictionary.add('25', { id: 25, customerCharacteristicCategoryType: 'Individual', value: 'CongressionalMedalofHonor', displayValue: 'Congressional Medal of Honor', description: 'To identify that the customer has a congressional medal of honor.', sortOrder: 999999, active: true });
        this._dictionary.add('26', { id: 26, customerCharacteristicCategoryType: 'Individual', value: 'Firefighter', displayValue: 'Firefighter', description: 'To identify that the customer is a firefighter.', sortOrder: 999999, active: true });
        this._dictionary.add('27', { id: 27, customerCharacteristicCategoryType: 'Individual', value: 'FormerPrisonerofWar', displayValue: 'Former Prisoner of War', description: 'To identify that the customer is a former prisoner of war.', sortOrder: 999999, active: true });
        this._dictionary.add('28', { id: 28, customerCharacteristicCategoryType: 'Individual', value: 'FraternalOrderofPolice', displayValue: 'Fraternal Order of Police', description: 'To identify that the customer belongs to the fraternal order of police.', sortOrder: 999999, active: true });
        this._dictionary.add('29', { id: 29, customerCharacteristicCategoryType: 'Individual', value: 'GoldStarFamily', displayValue: 'Gold Star Family', description: 'To identify that the customer belongs to the gold star family.', sortOrder: 999999, active: true });
        this._dictionary.add('30', { id: 30, customerCharacteristicCategoryType: 'Individual', value: 'Government', displayValue: 'Government', description: 'To identify that the customer is a government personnel', sortOrder: 999999, active: false });
        this._dictionary.add('32', { id: 32, customerCharacteristicCategoryType: 'Individual', value: 'HonoraryForeignConsular', displayValue: 'Honorary Foreign Consular', description: 'To identify that the customer is a member of the honorary foreign consular.', sortOrder: 999999, active: true });
        this._dictionary.add('33', { id: 33, customerCharacteristicCategoryType: 'Individual', value: 'LegionofValor', displayValue: 'Legion of Valor', description: 'To identify that the customer has a legion of valor.', sortOrder: 999999, active: true });
        this._dictionary.add('34', { id: 34, customerCharacteristicCategoryType: 'Individual', value: 'NationalGuard', displayValue: 'National Guard', description: 'To identify that the customer is in the national guard.', sortOrder: 999999, active: true });
        this._dictionary.add('35', { id: 35, customerCharacteristicCategoryType: 'Individual', value: 'OOP/IAH ', displayValue: 'OOP/IAH', description: 'To identify that the customer will have certain data redacted.', sortOrder: 999999, active: true });
        this._dictionary.add('36', { id: 36, customerCharacteristicCategoryType: 'Individual', value: 'PearlHarborSurvivor', displayValue: 'Pearl Harbor Survivor', description: 'To identify that the customer is a pearl harbor survivor.', sortOrder: 999999, active: true });
        this._dictionary.add('37', { id: 37, customerCharacteristicCategoryType: 'Individual', value: 'PurpleHeartMedal', displayValue: 'Purple Heart Medal', description: 'To identify that the customer has a purple heart medal.', sortOrder: 999999, active: true });
        this._dictionary.add('38', { id: 38, customerCharacteristicCategoryType: 'Individual', value: 'QualifiedSurvivingMemberforExemption', displayValue: 'Qualified Surviving Member for Exemption', description: 'To identify that the customer is a qualified surviving member to receive an exemption.', sortOrder: 999999, active: true });
        this._dictionary.add('39', { id: 39, customerCharacteristicCategoryType: 'Individual', value: 'QualifiedSurvivingMemberforPlate', displayValue: 'Qualified Surviving Member for Plate', description: 'To identify that the customer is a qualified surviving member to receive a plate.', sortOrder: 999999, active: true });
        this._dictionary.add('40', { id: 40, customerCharacteristicCategoryType: 'Individual', value: 'RestrictedRecord', displayValue: 'Restricted Record', description: 'To identify that the customer will have certain data redacted.', sortOrder: 999999, active: true });
        this._dictionary.add('43', { id: 43, customerCharacteristicCategoryType: 'Organization', value: 'PermanentlyDisabledTransporter', displayValue: 'Orgs that transport citizens with disabilities', description: 'Orgs that transport citizens with disabilities', sortOrder: 999999, active: true });
        this._dictionary.add('44', { id: 44, customerCharacteristicCategoryType: 'Individual', value: 'Intrinsic', displayValue: 'Intrinsic', description: 'Intrinsic', sortOrder: 999999, active: false });
        this._dictionary.add('45', { id: 45, customerCharacteristicCategoryType: 'Individual', value: 'Transient', displayValue: 'Transient ', description: 'Transient ', sortOrder: 999999, active: true });
        this._dictionary.add('46', { id: 46, customerCharacteristicCategoryType: 'Organization', value: 'ElectronicLienTitle', displayValue: 'Electronic Lien Title', description: 'Identifies the customer is an Electronic Lien Title participant.', sortOrder: 999999, active: true });
        this._dictionary.add('47', { id: 47, customerCharacteristicCategoryType: 'Individual', value: 'HearingImpaired', displayValue: 'Deaf / Hard of Hearing', description: 'Deaf / Hard of Hearing', sortOrder: 999999, active: true });
        this._dictionary.add('48', { id: 48, customerCharacteristicCategoryType: 'Individual', value: 'SuspendDigitalDisbursement', displayValue: 'Suspend Digital Disbursement', description: 'Suspend digital disbursement for customer', sortOrder: 999999, active: true });
        this._dictionary.add('50', { id: 50, customerCharacteristicCategoryType: 'Organization', value: 'PDSMotorcycle', displayValue: 'PDS - Motorcycle', description: 'Professional driving school authorized by the state to deliver Motorcycle driving courses', sortOrder: 999999, active: true });
        this._dictionary.add('51', { id: 51, customerCharacteristicCategoryType: 'Organization', value: 'PDSSpecialPerformance', displayValue: 'PDS - Special Performance', description: 'Professional driving school authorized by the state to deliver Special Performance/Adaptive driving courses', sortOrder: 999999, active: true });
        this._dictionary.add('52', { id: 52, customerCharacteristicCategoryType: 'Organization', value: 'RestrictedDistributor', displayValue: 'Restricted Distributor', description: 'Restricted Distributor. To be used for fuel tax refunds. ', sortOrder: 999999, active: true });
        this._dictionary.add('53', { id: 53, customerCharacteristicCategoryType: 'Organization', value: 'DepartmentofChildSafety', displayValue: 'Department of Child Safety', description: 'Department of Child Safety', sortOrder: 999999, active: true });
        this._dictionary.add('54', { id: 54, customerCharacteristicCategoryType: 'Organization', value: 'ScrapDealer', displayValue: 'Scrap Dealer', description: 'A business who purchases or collects vehicles for scrap and then sells it on for profit.', sortOrder: 999999, active: true });
        this._dictionary.add('55', { id: 55, customerCharacteristicCategoryType: 'Organization', value: 'AutoRecycler', displayValue: 'Auto Recycler', description: 'A business who is considered a Dealer that purchases vehicle for parts, crushing, dismantling, and recycling.', sortOrder: 999999, active: true });
        this._dictionary.add('56', { id: 56, customerCharacteristicCategoryType: 'Organization', value: 'Insurance', displayValue: 'Insurance', description: 'To identify that the customer is an insurance organization.', sortOrder: 999999, active: true });
        this._dictionary.add('57', { id: 57, customerCharacteristicCategoryType: 'Organization', value: 'Dealer', displayValue: 'Dealer', description: 'Dealer', sortOrder: 999999, active: true });
        this._dictionary.add('58', { id: 58, customerCharacteristicCategoryType: 'Organization', value: 'PDSOperator', displayValue: 'PDS - Operator', description: 'Professional driving school authorized by the state to deliver Non Commercial driving courses', sortOrder: 999999, active: true });
        this._dictionary.add('59', { id: 59, customerCharacteristicCategoryType: 'Organization', value: 'PDSHighSchool', displayValue: 'PDS - High School', description: 'Professional driving school authorized by the state to deliver Non Commercial driving courses', sortOrder: 999999, active: true });
        this._dictionary.add('60', { id: 60, customerCharacteristicCategoryType: 'Organization', value: 'MVDBusinessPartnerCustomer', displayValue: 'MVD Business Partner Customer', description: 'This characteristic will be used to prevent the record from being purged in MAX. These records need a legacy number to access business portals.', sortOrder: 999999, active: true });
        this._dictionary.add('61', { id: 61, customerCharacteristicCategoryType: 'Organization', value: 'TrafficSurvivalSchool', displayValue: 'Traffic Survival School', description: 'Traffic Survival School - Arizona Chapter - Nation Safety Council manages all TSS license schools along with scheduling, fees, and test results, ensuring revenue is passed along to ADOT.', sortOrder: 999999, active: true });
        this._dictionary.add('62', { id: 62, customerCharacteristicCategoryType: 'Individual', value: 'LightSensitivityWindowTint', displayValue: 'Light Sensitivity Window Tint', description: 'Light Sensitivity Window Tint', sortOrder: 999999, active: true });
        this._dictionary.add('63', { id: 63, customerCharacteristicCategoryType: 'Individual', value: 'RestrictedPortalAccount', displayValue: 'Restricted Portal Account', description: 'To identify that a customer has restricted access to services available in public portals.', sortOrder: 999999, active: true });
        this._dictionary.add('64', { id: 64, customerCharacteristicCategoryType: 'Organization', value: 'PDSCommercial', displayValue: 'PDS - Commercial', description: 'A driving school that is authorized by the state to deliver Commercial driving courses', sortOrder: 999999, active: true });
        this._dictionary.add('65', { id: 65, customerCharacteristicCategoryType: 'Organization', value: 'TrustedOrg', displayValue: 'Trusted Organization', description: 'Trusted Organization', sortOrder: 999999, active: true });
        this._dictionary.add('66', { id: 66, customerCharacteristicCategoryType: 'Organization', value: 'InformationServices', displayValue: 'Information Services', description: 'Information Services', sortOrder: 999999, active: true });
        this._dictionary.add('1065', { id: 1065, customerCharacteristicCategoryType: 'Organization', value: 'WatchYourCar', displayValue: 'Watch Your Car', description: 'Watch Your Car', sortOrder: 999999, active: true });
        this._dictionary.add('2065', { id: 2065, customerCharacteristicCategoryType: 'Organization', value: 'Ops of Law Placement', displayValue: 'Ops of Law Placement', description: 'Ops of Law Placement', sortOrder: 999999, active: true });
        this._dictionary.add('2066', { id: 2066, customerCharacteristicCategoryType: 'Organization', value: 'Secretary of State', displayValue: 'Secretary of State', description: 'To view images of DL applications for voter registration administration purposes', sortOrder: 999999, active: true });
        this._dictionary.add('2067', { id: 2067, customerCharacteristicCategoryType: 'Organization', value: 'AOC', displayValue: 'Administrative Offices of the Courts', description: 'To recognize the organization record as Administrative Offices of the Courts. AZ MVD Now Business Portal for TTEAP. ', sortOrder: 999999, active: true });
        this._dictionary.add('2068', { id: 2068, customerCharacteristicCategoryType: 'Organization', value: 'DisableABVNotifications', displayValue: 'Disable ABV Notifications', description: 'Do not send ABV Notifications to this customer.', sortOrder: 999999, active: true });
        this._dictionary.add('2069', { id: 2069, customerCharacteristicCategoryType: 'Organization', value: 'GovernmentMVRQualified', displayValue: 'Government MVR Qualified', description: 'To identify that the customer is government MVR qualified.', sortOrder: 999999, active: true });
        this._dictionary.add('2070', { id: 2070, customerCharacteristicCategoryType: 'Organization', value: 'OrgRestrictedRecord', displayValue: 'Organization Restricted Record', description: 'To identify organizations that have redacted data', sortOrder: 999999, active: true });
        this._dictionary.add('2071', { id: 2071, customerCharacteristicCategoryType: 'Organization', value: 'GovernmentPhotoQualified', displayValue: 'Government Photo Qualified', description: 'To identify that the customer is government photo qualified.', sortOrder: 999999, active: true });
        this._dictionary.add('2072', { id: 2072, customerCharacteristicCategoryType: 'Individual', value: 'ParentGaurdianOfPermDisabledMinor', displayValue: 'Parent Guardian Of Permanently Disabled Minor', description: 'Parent Guardian Of Permanently Disabled Minor', sortOrder: 999999, active: true });
        this._dictionary.add('2073', { id: 2073, customerCharacteristicCategoryType: 'Individual', value: 'IndElevatedMAXBalance', displayValue: 'Individual Elevated MAX Balance', description: 'Allows customer to have a larger account balance', sortOrder: 999999, active: true });
        this._dictionary.add('2074', { id: 2074, customerCharacteristicCategoryType: 'Organization', value: 'OrgElevatedMAXBalance', displayValue: 'Organization Elevated MAX Balance', description: 'Allows customer to have a larger account balance', sortOrder: 999999, active: true });
        this._dictionary.add('2075', { id: 2075, customerCharacteristicCategoryType: 'Individual', value: 'HumanitarianParole', displayValue: 'Humanitarian Parole', description: 'Humanitarian Parole', sortOrder: 999999, active: true });
        this._dictionary.add('2076', { id: 2076, customerCharacteristicCategoryType: 'Organization', value: 'OrgOOP/IAH', displayValue: 'Organization OOP/IAH', description: 'Organization OOP/IAH', sortOrder: 999999, active: true });
        this._dictionary.add('2077', { id: 2077, customerCharacteristicCategoryType: 'Organization', value: 'OrgCDLMECMVR', displayValue: 'Organization CDL MEC MVR', description: 'Allows organizations to view CDL MVRs.', sortOrder: 999999, active: true });
        this._dictionary.add('2078', { id: 2078, customerCharacteristicCategoryType: 'Individual', value: 'IRP/IFTA', displayValue: 'IRP/IFTA', description: 'IRP/IFTA', sortOrder: 999999, active: true });
        this._dictionary.add('2079', { id: 2079, customerCharacteristicCategoryType: 'Individual', value: 'Non-ResidentMilitarySpouse', displayValue: 'Non-Resident Military Spouse', description: 'Non-Resident Military Spouse', sortOrder: 999999, active: true });
        this._dictionary.add('2080', { id: 2080, customerCharacteristicCategoryType: 'Organization', value: 'GovernmentComplianceReport', displayValue: 'Government Compliance Report', description: 'Government Compliance Report', sortOrder: 999999, active: true });
        this._dictionary.add('2081', { id: 2081, customerCharacteristicCategoryType: 'Individual', value: 'MotorCarrierIndividual', displayValue: 'Motor Carrier Individual', description: 'To identify that the customer has a motor carrier account.', sortOrder: 999999, active: true });
        this._dictionary.add('2082', { id: 2082, customerCharacteristicCategoryType: 'Organization', value: 'MotorCarrierOrganization', displayValue: 'Motor Carrier Organization', description: 'To identify that the organization has a motor carrier account.', sortOrder: 999999, active: true });
        this._dictionary.add('2083', { id: 2083, customerCharacteristicCategoryType: 'Organization', value: 'MotorCarrierProcessor', displayValue: 'Motor Carrier Processor', description: 'To identify that the customer is a process agent for motor carrier.', sortOrder: 999999, active: true });
        this._dictionary.add('2084', { id: 2084, customerCharacteristicCategoryType: 'Individual', value: 'PurpleHeartRecipient', displayValue: 'Purple Heart Recipient', description: 'Purple Heart Recipient', sortOrder: 999999, active: true });
        this._dictionary.add('2085', { id: 2085, customerCharacteristicCategoryType: 'Organization', value: 'MVDNowOrgVehicleMVR', displayValue: 'AZMVDNow Org Vehicle MVR', description: 'Allow orgs to order vehicle MVRs on AZMVDNow.', sortOrder: 999999, active: true });
        this._dictionary.add('2086', { id: 2086, customerCharacteristicCategoryType: 'Organization', value: 'FinancialInstitution', displayValue: 'Financial Institution', description: 'Financial Institution', sortOrder: 999999, active: true });
        this._dictionary.add('2087', { id: 2087, customerCharacteristicCategoryType: 'Individual', value: 'ImmediateFamilyMemberofaVeteranforPlate', displayValue: 'Immediate Family Member of a Veteran for Plate', description: 'Immediate Family Member of a Veteran for Plate', sortOrder: 999999, active: true });
        this._dictionary.add('2088', { id: 2088, customerCharacteristicCategoryType: 'Individual', value: 'DistinguishedFlyingCross', displayValue: 'Distinguished Flying Cross', description: 'Distinguished Flying Cross', sortOrder: 999999, active: true });
        this._dictionary.add('2089', { id: 2089, customerCharacteristicCategoryType: 'Organization', value: 'InsuranceInstitution', displayValue: 'Insurance Institution', description: 'Insurance Institution', sortOrder: 999999, active: true });
        this._dictionary.add('2090', { id: 2090, customerCharacteristicCategoryType: 'Organization', value: 'IRP/IFTAOrg', displayValue: 'IRP/IFTA', description: 'IRP/IFTA', sortOrder: 999999, active: true });
        this._dictionary.add('2091', { id: 2091, customerCharacteristicCategoryType: 'Organization', value: 'LimitedTrustOrg', displayValue: 'Limited Trust Organization', description: 'Limited Trust Organization', sortOrder: 999999, active: true });
        this._dictionary.add('2092', { id: 2092, customerCharacteristicCategoryType: 'Organization', value: 'TeleMVDKioskLocation', displayValue: 'TeleMVD Kiosk Location', description: 'Locations that have a TeleMVD kiosk', sortOrder: 999999, active: true });
        this._dictionary.add('2093', { id: 2093, customerCharacteristicCategoryType: 'Organization', value: 'Tower', displayValue: 'Tower', description: 'Tower', sortOrder: 999999, active: true });
        this._dictionary.add('2094', { id: 2094, customerCharacteristicCategoryType: 'Organization', value: 'ADCRR', displayValue: 'Arizona DoC Rehabilitation and Reentry', description: 'Arizona DoC Rehabilitation and Reentry', sortOrder: 999999, active: true });
        this._dictionary.add('2095', { id: 2095, customerCharacteristicCategoryType: 'Organization', value: 'GovernmentVehicleDocuments', displayValue: 'Government Vehicle Documents', description: 'Allows government agencies to view all vehicle documents via MVD Now', sortOrder: 999999, active: true });
        this._dictionary.add('2096', { id: 2096, customerCharacteristicCategoryType: 'Organization', value: 'CrashRecordsViewer', displayValue: 'Crash Records Viewer', description: 'Crash Records Viewer', sortOrder: 999999, active: true });
        this._dictionary.add('2097', { id: 2097, customerCharacteristicCategoryType: 'Organization', value: 'CrashRecordsDPS', displayValue: 'Crash Records DPS', description: 'Crash Records DPS', sortOrder: 999999, active: true });
        this._dictionary.add('2098', { id: 2098, customerCharacteristicCategoryType: 'Organization', value: 'DonorNetworkReports', displayValue: 'Donor Network Reports', description: 'Allows Donor Network of AZ access to reports created for them', sortOrder: 999999, active: true });
        this._dictionary.add('2099', { id: 2099, customerCharacteristicCategoryType: 'Organization', value: 'GovernmentFeeExemption', displayValue: 'Government Fee Exemption', description: 'Exempts fees for Govt agencies', sortOrder: 999999, active: true });
        this._dictionary.add('2100', { id: 2100, customerCharacteristicCategoryType: 'Organization', value: 'MobileHome', displayValue: 'Mobile Home', description: 'Mobile Home', sortOrder: 999999, active: true });
        this._dictionary.add('2101', { id: 2101, customerCharacteristicCategoryType: 'Individual', value: 'Pre96', displayValue: 'Pre 96', description: 'Used for HAVA requirements', sortOrder: 999999, active: true });
        this._dictionary.add('2102', { id: 2102, customerCharacteristicCategoryType: 'Individual', value: 'OHVEducationIndividual', displayValue: 'OHV Education Individual', description: 'To identify individual customers that have completed the OHV Education test through AMN.', sortOrder: 999999, active: true });
        this._dictionary.add('2103', { id: 2103, customerCharacteristicCategoryType: 'Organization', value: 'OHVEducationOrganization', displayValue: 'OHV Education Organization', description: 'To identify organization customers that have completed the OHV Education test through AMN.', sortOrder: 999999, active: true });
        this._dictionary.add('2104', { id: 2104, customerCharacteristicCategoryType: 'Individual', value: 'ClaimAMNAccountInOffice', displayValue: 'Claim AMN Account In Office', description: 'Claim AMN Account In Office', sortOrder: 999999, active: true });
        this._dictionary.add('2105', { id: 2105, customerCharacteristicCategoryType: 'Individual', value: 'CommunicationAccommodationVehicle', displayValue: 'Communication Accommodation - Vehicle', description: 'Communication Accommodation - Vehicle', sortOrder: 999999, active: true });
        this._dictionary.add('2106', { id: 2106, customerCharacteristicCategoryType: 'Individual', value: 'CommunicationAccommodationCustomer', displayValue: 'Communication Accommodation - Customer', description: 'Communication Accommodation - Customer', sortOrder: 999999, active: true });
        this._dictionary.add('2108', { id: 2108, customerCharacteristicCategoryType: 'Individual', value: 'NativeAmericanCredentialDesignation', displayValue: 'Native American Credential Designation', description: 'To identify that the customer has a Native American Credential Designation', sortOrder: 999999, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerCharacteristicType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerCharacteristicType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerCharacteristicType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerCharacteristicType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerCharacteristicType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        const get = (obj, path) => {
            if (path) {
                path = path.split('.');

                for (var i = 0, len = path.length - 1; i < len; i++) {
                    obj = obj[path[i]];
                }

                return obj[path[len]];
            }
            return obj;
        };

        const prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            const A = prime(a);
            const B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
